import React from 'react';
import EventsHomePage from './events-home-page';

import { useWindowSize } from 'utils/useWindowSize';
import { connect } from 'redux-scaffolding-ts';
import { EventsStore } from 'stores/events/events-store';
import MobileEventsContainer from './mobile-events-container';

const EventListContainer: React.FC<any> = props => {
  const { width } = useWindowSize();
  const isMobile = width < 768;

  return isMobile ? (
    <MobileEventsContainer eventsStore={props.eventsStore} {...props} />
  ) : (
    <EventsHomePage eventsStore={props.eventsStore} {...props} />
  );
};

export default connect(['eventsStore', EventsStore])(EventListContainer);
